import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  action?: ReactNode;
  center?: boolean;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  action,
  center = false,
}: SectionHeadingProps) {
  return (
    <div
      className={`flex flex-col gap-5 ${
        center
          ? "items-center text-center"
          : "md:flex-row md:items-end md:justify-between md:text-left"
      }`}
    >
      <div className={center ? "max-w-2xl" : "max-w-2xl"}>
        <span className="inline-flex items-center gap-2 text-sm font-semibold text-accent-600">
          <span className="w-6 h-[2px] bg-accent-500"></span>
          {eyebrow}
        </span>
        <h2 className="mt-3 font-heading text-2xl md:text-4xl font-extrabold text-foreground-950 tracking-tight">
          {title}
        </h2>
        {desc && <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">{desc}</p>}
      </div>
      {action}
    </div>
  );
}